export default __webpack_public_path__ + "static/media/q27_step7.fd3226f8.png";